<section>
  @if (!benefitGroup.hideLabel) {
    <div class="benefit-group-header">
      <div class="center-inside">
        <h2>{{benefitGroup.name}}</h2>
      </div>
    </div>
  }

  <div class="bordered-container">

    <!-- Medical Benefits-->
    @if (isMedicalBenefitType(benefitGroup)) {
      <app-medical-benefit
        [benefitGroup]="benefitGroup"
      ></app-medical-benefit>
    }

    <!-- PLAN DOCUMENTS -->
    @if (isPlanDocumentBenefitType(benefitGroup) && isPlanDetailsFlow()) {
      <app-plan-documents
      [benefitGroup]="benefitGroup"></app-plan-documents>
    }
  </div>
</section>
